import request from '@/utils/request'
import host from '@/api/base/host'
import { AsyncRequest } from '@/utils/request'
const apiUrl = host.path('dev', { module: 'baijiayue', dev: 'v1/live' })

export default {
  getLiveSign(data) {
    return request({
      url: apiUrl('sign'),
      method: 'post',
      data
    })
  },
  //
  getLiveDetail(data) {
    return request({
      url: apiUrl('view'),
      method: 'post',
      data
    })
  },
  yyLive(data) {
    return request({
      url: apiUrl('book'),
      method: 'post',
      data
    })
  }
}
